export default "__VITE_ASSET__4beb7125__"